import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import about from '@/components/about' //品牌故事
import store from '@/components/store' //門店
import goods from '@/components/goods' //翡翠/祖母綠等
import goodDetail from '@/components/good-detail' //商品详情
import customized from '@/components/customized' //定制
import diamond from '@/components/diamond' //钻石
import spinel from '@/components/spinel' //尖晶石
import encyclopedias from '@/components/encyclopedias' //珠宝百科
import encyDetail from '@/components/ency-detail' //珠宝百科详情
Vue.use(Router)

let routerArr = new Router({
  routes: [
    {
      path: '/',
      name: '首頁',
      component: HelloWorld
    },
    {
      path: '/about',
      name: '關於讀道',
      component: about
    },
    {
      path: '/store',
      name: '門店展示',
      component: store
    },
    {
      path: '/customized',
      name: '裸石高级定制',
      component: customized
    },
    {
      path: '/diamond',
      name: '钻石系列',
      component: diamond,
      children: [
        {
          path: '/diamond/detail',
          name: '钻石系列-详情',
          component: goodDetail
        }

      ]
    },
    {
      path: '/spinel',
      name: '尖晶石系列',
      component: spinel,
      children: [
        {
          path: '/spinel/detail',
          name: '尖晶石系列-详情',
          component: goodDetail
        }
      ]
    },
    {
      path: '/encyclopedias',
      name: '珠宝百科',
      component: encyclopedias
    },
    {
      path: '/ency-detail',
      name: '珠宝百科-详情',
      component: encyDetail
    },
    {
      path: '/jadeite',
      name: '翡翠系列',
      component: goods,
      children: [
        {
          path: '/jadeite/detail',
          name: '翡翠-详情',
          component: goodDetail
        }

      ]
    },
    {
      path: '/emerald',
      name: '祖母綠系列',
      component: goods,
      children: [
        {
          path: '/emerald/detail',
          name: '祖母绿-详情',
          component: goodDetail
        }

      ]
    }
  ]
})
routerArr.beforeEach((t, b, n) => {
  window.scrollTo(0, 0)
  document.getElementsByTagName('title')[0].innerHTML = '讀道-' + t.name
  n()
})
export default routerArr



// WEBPACK FOOTER //
// ./src/router/index.js